// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2S5Ad","dragIcon":"Choice_dragIcon__1Nsk8","left":"Choice_left__27FYm","input":"Choice_input__3S7xN"};